import { render } from "./Shapes.vue?vue&type=template&id=41b746f7"
import script from "./Shapes.vue?vue&type=script&lang=js"
export * from "./Shapes.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__